import { isMobileScreen } from "./screenBreakpoints";

export class SmoothSlider {
    private startTime!: number;
    private startOffset: number = 0;
    private targetOffset: number = 0;
    private activeTimer?: number;

    public constructor(
        private slidingElement: HTMLElement, 
        private parentElement: HTMLElement, 
        private topPadding: number,
        private duration: number) {
        
    }

    public onWindowChange(): void {
        if (isMobileScreen()) {
            return;
        }

        //var headerPadding = 99;
        //var topPadding = 20;
        //var fixedOffset = headerPadding + topPadding;
        
        var contentsBounds = this.parentElement.getBoundingClientRect();
        var focusedBounds = this.slidingElement.getBoundingClientRect();

        var treloffset = this.topPadding - contentsBounds.top;
        var offset: number = 0;

        if (treloffset > 0) {
            offset = treloffset;
            var apparentBottom = contentsBounds.bottom - this.topPadding;

            if (focusedBounds.height > apparentBottom) {
                offset -= (focusedBounds.height - apparentBottom);
            }
        }
        
        this.slideTo(focusedBounds.top - contentsBounds.top, offset);
    }

    public slideTo(from: number, to: number): void {
        this.startTime = Date.now();
        this.startOffset = from;
        this.targetOffset = to;
        
        if (!this.activeTimer) {
            this.activeTimer = this.startRun();
        }
    }

    private startRun(): number {
        return window.setInterval(() => this.onRun(), 10);
    }

    private onRun(): void {
        var currTime = Date.now();
        var elapsedMs = currTime - this.startTime;
        var elapsedPercent = Math.min(1, elapsedMs / this.duration);

        var currOffset = this.lerp(this.startOffset, this.targetOffset, elapsedPercent);
        
        this.slidingElement.style.setProperty("transform", `translateY(${currOffset}px)`);

        if (elapsedPercent >= 1) {
            window.clearInterval(this.activeTimer!);
            this.activeTimer = undefined;
        }
    }

    private lerp(x: number, y: number, a: number) {
        a = this.easeSine(a);
        return (x * (1 - a)) + (y * a);
    }

    private easeSine(x: number): number {
        return Math.sin((x * Math.PI) / 2);
    }
}